module.exports = __webpack_public_path__ + "static/noteeth-3369c87e3bf042a0d72906e9f9f9998f.jpg";